export default "__VITE_ASSET__V_pji5fS__"